import { config } from "../../helpers";
import { ALL_SALES, EXTERNAL_USERS } from "../../helpers/roles"


export const ChannelListFilter = [
    { value: "Display" }, 
    { value: "Social Amplifier" },
    { value: "Rich Media" },
    { value: "Instream Video" },
    { value: "Digital OOH" },
];
const commbankChannel = [
    { value: "In-Branch", link: "in-branch", icon: "fas fa-building" },
    { value: "Digital", link: "digital", icon: "fas fa-mobile-alt"},
    { value: "Content", link: "content", icon: "fas fa-align-left"},
]
const regularChannel = (role = 1) => [
    { value: "Display", link: "display", icon: "fas fa-image", hasAIAlpha: true }, 
    { value: "Social Amplifier", link: "social-media", icon: "fas fa-thumbs-up", hasAIAlpha: true },
    { value: "Rich Media", link: "rich-media", icon: "fas fa-cube", hasAIAlpha: true },    
    { value: "Instream Video", link: "instream-video", icon: "fas fa-play-circle", hasAIAlpha: true },
    //{ value: "VOD", link: "vod", icon: "fas fa-tv", disabled: [...EXTERNAL_USERS, ...ALL_SALES].includes(role) },
    // { value: "Venues", elink: "https://venues.bigads.co", disabled: [...EXTERNAL_USERS].includes(role) },
    { value: "Digital OOH", link: "digital-ooh", icon: "fas fa-city" },
]
const mediumrareChannel = (role = 1) => [
    { value: "In-store", subText: "Retailer", link: "in-store", icon: "fas fa-store" },
    { value: "On-site", subText: "Retailer", link: "on-site", svgIcon: <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" viewBox="0 0 92 92" fill="none"> <path className="custom-svg-path" d="M7.6665 76.6663V68.9997H45.9998V76.6663H7.6665ZM19.1665 65.1663C17.0582 65.1663 15.2533 64.4156 13.7519 62.9143C12.2505 61.4129 11.4998 59.608 11.4998 57.4997V22.9997C11.4998 20.8913 12.2505 19.0865 13.7519 17.5851C15.2533 16.0837 17.0582 15.333 19.1665 15.333H72.8332C74.9415 15.333 76.7464 16.0837 78.2477 17.5851C79.7491 19.0865 80.4998 20.8913 80.4998 22.9997H19.1665V57.4997H45.9998V65.1663H19.1665ZM76.6665 68.9997V38.333H61.3332V68.9997H76.6665ZM59.4165 76.6663C57.8193 76.6663 56.4616 76.1073 55.3436 74.9893C54.2255 73.8712 53.6665 72.5136 53.6665 70.9163V36.4163C53.6665 34.8191 54.2255 33.4615 55.3436 32.3434C56.4616 31.2254 57.8193 30.6663 59.4165 30.6663H78.5832C80.1804 30.6663 81.538 31.2254 82.6561 32.3434C83.7741 33.4615 84.3332 34.8191 84.3332 36.4163V70.9163C84.3332 72.5136 83.7741 73.8712 82.6561 74.9893C81.538 76.1073 80.1804 76.6663 78.5832 76.6663H59.4165ZM68.9998 47.9163C69.8304 47.9163 70.5172 47.6288 71.0603 47.0538C71.6033 46.4788 71.8748 45.808 71.8748 45.0413C71.8748 44.2108 71.6033 43.524 71.0603 42.9809C70.5172 42.4379 69.8304 42.1663 68.9998 42.1663C68.2332 42.1663 67.5623 42.4379 66.9873 42.9809C66.4123 43.524 66.1248 44.2108 66.1248 45.0413C66.1248 45.808 66.4123 46.4788 66.9873 47.0538C67.5623 47.6288 68.2332 47.9163 68.9998 47.9163Z" fill="#CACBD3" fillOpacity="0.2"/></svg>},
    { value: "Direct channel", subText: "Retailer", link: "direct-channel", svgIcon: <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" viewBox="0 0 92 92" fill="none"><path className="custom-svg-path" d="M13.6229 81.0735C11.8595 81.0735 10.3307 80.4259 9.03629 79.1309C7.74126 77.8365 7.09375 76.3077 7.09375 74.5443V17.4564C7.09375 15.6867 7.74126 14.1524 9.03629 12.8535C10.3307 11.554 11.8595 10.9043 13.6229 10.9043H78.3775C80.1472 10.9043 81.6815 11.554 82.9803 12.8535C84.2798 14.1524 84.9296 15.6867 84.9296 17.4564V74.5443C84.9296 76.3077 84.2798 77.8365 82.9803 79.1309C81.6815 80.4259 80.1472 81.0735 78.3775 81.0735H13.6229ZM13.6229 74.5443H78.3775V17.4564H13.6229V74.5443ZM23.9777 64.477H68.0457V58.727H23.9777V64.477ZM23.9777 48.6837H38.8318V27.5007H23.9777V48.6837ZM48.6835 48.6837H68.0457V42.9337H48.6835V48.6837ZM48.6835 33.2507H68.0457V27.5007H48.6835V33.2507Z" fill="#CACBD3" fillOpacity="0.2"/></svg>},
    
    { value: "Display", subText: "Off-site", link: "display", icon: "fas fa-image", hidden: true }, 
    { value: "Rich Media", subText: "Off-site", link: "rich-media", icon: "fas fa-cube", hidden: true},    
    { value: "Instream Video", subText: "Off-site", link: "instream-video", icon: "fas fa-play-circle", hidden: true },
    { value: "Digital OOH", subText: "Off-site", link: "digital-ooh", icon: "fas fa-city", hidden: true},
    { value: "Social Amplifier", subText: "Off-site", link: "social-media", icon: "fas fa-thumbs-up", hidden: true },
]
export const ChannelList = (role = 1) => config.mediumrare ? mediumrareChannel(role) : config.commbank ? commbankChannel : regularChannel(role);
export const defaultDSP ={
    "id": 10000,
    "nameRubicon": null,
    "network_id": 100000,
    "is_available_for_dooh": false,
    "slug": "doubleclick",
    "title": "Google Ad Manager",
    "click_macro": "%%CLICK_URL_UNESC%%YOURURLHERE",
    "redir_url": "YOURURLHERE",
    "statusBuddy": 1,
    "nameBuddy": "Google Ad Manager",
    "createdBy": "81fd347d-a288-4a95-93c6-ace87d981991",
    "createdAt": "2001-01-01 00:58:00",
    "updatedAt": null,
    "buyer_seat_id": 100000,
    "airtory_name": "DoubleClick for Publishers",
    "airtory_macros": "  {\n    \"click_url\": \"%%CLICK_URL_UNESC%%\",\n    \"cachebuster\": \"%%CACHEBUSTER%%\"\n  }",
    "code": "GAM",
    "external_id": "mo337qG",
    "mg_info": null,
    "buyerId": ""
}
export const getChannel = (value, role) => ChannelList(role).find(c => c.link === value);

export const channelInfo = {
    "In-Branch": [{
        name: "Digital Screens",
        description: "Full-motion digital screens positioned both external to and in-branch, maximising walk-by exposure and high-dwell environments to maximise the story-telling in key moments of receptivity.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/inBranch-screens.jpg",
        details: [
            { icon: "fas fa-desktop", label: "Screens", value: "1,297" },
            { icon: "fas fa-university", label: "Branches", value: "464" }
        ]
    },
    {
        name: "Media Walls",
        description: "Located in our largest, most trafficked branches across Australia in metro locations only and placed in high dwell locations near concierge for maximum exposure and impact.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/inBranch-walls.jpg",
        details: [
            { icon: "fas fa-university", label: "Branches", value: "50" }
        ]
    },
    {
        name: "ATMs",
        description: "A one to one, captive moment to inspire and create an ‘epic content moment’ during a time of pause.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/inBranch-atm.png",
        details: [
            { icon: "fas fa-money-bill-wave", label: "ATM locations", value: "1,856" }
        ]
    }],
    "Digital": [{
        name: "Digital",
        description: "Leveraging the CommBank homepage and CommBank Yello app to drive value-centric partner content and offers.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/digital.png",
        details: [
            { icon: "fas fa-eye", label: "Homepage visits", value: "7M p/m" },
            { icon: "fas fa-mobile-alt", label: "In-app users", value: "1.6M active users p/m" }
        ]
    }],
    "Content": [{
        name: "Content",
        description: "Industry-leading content curation used to educate and share the unique stories of our travel partners. Brighter Magazine is distributed within 660+ CBA branches nationwide and extended digitally for further amplification.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/content.png",
        details: [
            { icon: "fas fa-newspaper", label: "Magazine copies", value: "140K copies bi-monthly" },
        ]
    }],
    "In-store": [{
        name: "In-store",
        subTitle: "Retailer",
        description: "In-store retail media ad space are displays used by retailers to showcase promotional content, advertising, and other engaging information to customers within their physical stores. This can include digital signage, Point-of-sale displays or Interactive Kiosks.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/in-store.png",
        details: [
            { icon: "fas fa-store", label: "Retailers", value: "7" },
            { icon: "fas fa-map-pin", label: "Locations", value: "7,912" },
            { icon: "fas fa-desktop", label: "Screens", value: "27,504" },
        ]
    }],
    "On-site": [{
        name: "On-site",
        subTitle: "Retailer",
        description: "On-site retail media ad space refers to advertising placements within the retailer's own digital properties, such as their website or mobile app. This can include sponsored product listings, display or video ads on product pages and homepages. These are are typically targeted based on user behaviour and search intent.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/on-site.png",
        details: [
            { icon: "fas fa-store", label: "Retailers", value: "7" },
            { icon: "fas fa-user", label: "Unique Browsers", value: "18M UBs p/m" },
        ]
    }],
    "Direct channel": [{
        name: "Direct channel",
        subTitle: "Retailer",
        description: "Direct Channel retail media ad space refers to the various ways retailers connect with consumers and promote and sell products directly. This can include email marketing, direct mail and catalogues and mobile messaging.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/direct-channel.png",
        details: [
            { icon: "fas fa-store", label: "Retailers", value: "7" },
        ]
    }],
    "Display": [{
        name: "Display",
        subTitle: "Off-site",
        description: "Off-site display advertising is a form of online advertising using digital banners that are place on websites, apps or other digital platforms",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/display.png",
        details: [
            { icon: "fas fa-newspaper", label: "Sites", value: "188" },
            { icon: "fas fa-user", label: "Unique Browsers", value: "23M UBs p/m" },
        ]
    }],
    "Rich Media": [{
        name: "Rich Media",
        subTitle: "Off-site",
        description: "Off-site Rich Media advertising are interactive online ads that go beyond static images and text, incorporating elements like video, audio, animation and user interaction. They aim to grab attention and encourage engagement, creating a more immersive experience for the user. ",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/rich-media.png",
        details: [
            { icon: "fas fa-newspaper", label: "Sites", value: "456" },
            { icon: "fas fa-user", label: "Unique Browsers", value: "18M UBs p/m" },
        ]
    }],
    "Instream Video": [{
        name: "Instream Video",
        subTitle: "Off-site",
        description: "Off-site Instream Video are video ads that play within a video stream, typically appearing before, during or after the main video content.",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/instream.png",
        details: [
            { icon: "fas fa-newspaper", label: "Sites", value: "3011" },
            { icon: "fas fa-user", label: "Unique Browsers", value: "11M UBs p/m" },
        ]
    }],
    "Digital OOH": [{
        name: "Digital OOH",
        subTitle: "Off-site",
        description: "Off-site Digital Out-of-Home (OOH) advertising refers to ads displayed on digital screens in public spaces. ",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/dooh.png",
        details: [
            { icon: "fas fa-user-tie", label: "Media Owners", value: "10" },
            { icon: "fas fa-store", label: "Venues", value: "10K" },
            { icon: "fas fa-desktop", label: "Screens", value: "13.5K" },
        ]
    }],
    "Social Amplifier": [{
        name: "Social Amplifier",
        subTitle: "Off-site",
        description: "Off-site Social Amplifier ads allow you to take your social ads off the social platforms and re-use those creative assets across the broader open web. Social amplifier ads are a versatile way to extend the reach of your social media activity, and can also contribute likes and shares back to your social media posts",
        image: "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/commbank/social-amp.png",
        details: [
            { icon: "fas fa-newspaper", label: "Sites", value: "172" },
            { icon: "fas fa-user", label: "Unique Browsers", value: "18M UBs p/m" },
        ]
    }]
}
